<nz-layout class="bg-white">
  <nz-content class="px-10 pt-20">
    <div class="pb-20">
      <p class="text-2xl font-bold text-primary pb-10">Anstehende Termine</p>
      <div class="flex space-x-10">
        <nz-badge [nzCount]="startingRequestsAmount" nzShowZero="true">
          <nz-card
            [nzBordered]="false"
            class="dashboard-box rounded-xl bg-lime-500"
            (click)="onClickProvisionRequests('starting')"
          >
            <div>Bald beginnende Versorgungsanfragen</div>
          </nz-card>
        </nz-badge>
        <nz-badge [nzCount]="endingRequestsAmount" nzShowZero="true">
          <nz-card
            [nzBordered]="false"
            class="dashboard-box rounded-xl bg-red-500"
            (click)="onClickProvisionRequests('ending')"
          >
            <div>Bald endende Versorgungsanfragen</div>
          </nz-card>
        </nz-badge>
        <nz-badge [nzCount]="expiredRequestsAmount" nzShowZero="true">
          <nz-card
            [nzBordered]="false"
            class="dashboard-box rounded-xl bg-rose-700"
            (click)="onClickProvisionRequests('expired')"
          >
            <div>Ausgelaufene Versorgungsanfragen</div>
          </nz-card>
        </nz-badge>
      </div>
    </div>
    <div class="pb-20">
      <p class="text-2xl font-bold text-primary pb-10">
        Person oder Kleidung scannen
      </p>
      <div class="flex space-x-10">
        <nz-card
          class="dashboard-box size-48 rounded-xl hover:shadow-lg cursor-pointer p-0 inline-block"
          (click)="openScannerModal(0, 'Person scannen')"
          [nzBodyStyle]="{ 'align-content': 'center' }"
        >
          <div class="content-center flex flex-col items-center space-y-5">
            <i
              nz-icon
              nzType="smile"
              nzTheme="fill"
              class="text-5xl text-primary"
            ></i>
            <div class="text-lg font-semibold text-primary">Person scannen</div>
          </div>
        </nz-card>
        <nz-card
          class="dashboard-box rounded-xl hover:shadow-lg cursor-pointer p-0 inline-block"
          (click)="openScannerModal(1, 'Massenrücknahme')"
          [nzBodyStyle]="{ 'align-content': 'center' }"
        >
          <div class="flex flex-col items-center justify-center space-y-5">
            <i
              nz-icon
              nzType="tags"
              nzTheme="fill"
              class="text-5xl text-primary"
            ></i>
            <div class="text-lg font-semibold text-primary">
              Massenrücknahme
            </div>
          </div>
        </nz-card>
        <nz-card
          class="dashboard-box rounded-xl hover:shadow-lg cursor-pointer p-0 inline-block"
          (click)="openScannerModal(2, 'Wäschereirücknahme')"
          [nzBodyStyle]="{ 'align-content': 'center' }"
        >
          <div class="flex flex-col items-center justify-center space-y-5">
            <i
              nz-icon
              nzType="skin"
              nzTheme="fill"
              class="text-5xl text-primary"
            ></i>
            <div class="text-lg font-semibold text-primary">
              Wäschereirücknahme
            </div>
          </div>
        </nz-card>
      </div>
      <nz-modal
        [(nzVisible)]="scannerModalVisible"
        [nzTitle]="modalTitle"
        (nzOnCancel)="closeScannerModel()"
        [nzFooter]="null"
      >
        <ng-container *nzModalContent>
          <div class="flex flex-col items-center justify-center space-y-5 pb-2">
            <p class="text-2xl">Scanvorgang gestartet</p>
            <nz-spin nzSimple nzSize="large"></nz-spin>
          </div>
        </ng-container>
      </nz-modal>
    </div>
    <div class="flex space-x-10">
      <div class="flex flex-col w-full max-w-[700px]">
        <p class="text-2xl font-bold text-primary pb-10">
          Personen mit Zweitschlüssel
        </p>
        <nz-spin [nzSpinning]="keyLoading">
          <nz-card
            class="bg-gray-100 rounded-xl w-full max-w-[700px] min-h-[400px] flex flex-col"
          >
            <ng-container *ngIf="!keyLoading">
              <ng-container *ngIf="secondKeyPersons.length > 0; else noKeys">
                <cdk-virtual-scroll-viewport
                  itemSize="73"
                  style="height: 400px; width: 100%"
                >
                  <nz-list nzItemLayout="horizontal">
                    <nz-list-item
                      *cdkVirtualFor="let person of secondKeyPersons"
                      (click)="navigateToPerson(person.id)"
                      class="cursor-pointer hover:bg-white p-1.5"
                    >
                      <nz-list-item-meta
                        [nzDescription]="person.vorname + ' ' + person.name"
                      >
                        <nz-list-item-meta-title>
                          <ng-container *ngFor="let locker of person.spinde">
                            <ng-container
                              *ngIf="
                                locker.zweitschluessel_ausgegeben_am !== null
                              "
                            >
                              <div>
                                Spindnummer: {{ locker.bezeichnung }} |
                                Ausgeliehen seit:
                                {{
                                  DateTime.fromISO(
                                    locker.zweitschluessel_ausgegeben_am
                                  ).toFormat('dd-MM-yyyy')
                                }}
                              </div>
                            </ng-container>
                          </ng-container>
                        </nz-list-item-meta-title>
                      </nz-list-item-meta>
                    </nz-list-item>
                  </nz-list>
                </cdk-virtual-scroll-viewport>
              </ng-container>
            </ng-container>
          </nz-card>
        </nz-spin>
      </div>
      <div class="flex flex-col w-full max-w-[700px]">
        <p class="text-2xl font-bold text-primary pb-10">
          Personen mit Leihschuhen
        </p>
        <nz-spin [nzSpinning]="shoesLoading">
          <nz-card
            class="bg-gray-100 rounded-xl w-full max-w-[700px] min-h-[400px] flex flex-col"
          >
            <ng-container *ngIf="!shoesLoading">
              <ng-container *ngIf="wornPairOfShoes.length > 0; else noShoes">
                <cdk-virtual-scroll-viewport
                  itemSize="73"
                  style="height: 400px; width: 100%"
                >
                  <nz-list nzItemLayout="horizontal">
                    <nz-list-item
                      *cdkVirtualFor="let shoes of wornPairOfShoes"
                      (click)="navigateToPerson(shoes.person.id)"
                      class="cursor-pointer hover:bg-white p-1.5"
                    >
                      <nz-list-item-meta
                        [nzDescription]="
                          shoes.person.vorname + ' ' + shoes.person.name
                        "
                      >
                        <nz-list-item-meta-title>
                          Schuhbezeichnung: {{ shoes.bezeichnung }} |
                          Schuhgröße: {{ shoes.kleidergroesse_text }}
                        </nz-list-item-meta-title>
                      </nz-list-item-meta>
                    </nz-list-item>
                  </nz-list>
                </cdk-virtual-scroll-viewport>
              </ng-container>
            </ng-container>
          </nz-card>
        </nz-spin>
      </div>
    </div>
  </nz-content>
</nz-layout>

<ng-template #noShoes>
  <div class="flex items-center justify-center w-full h-[400px]">
    <nz-list-empty></nz-list-empty>
  </div>
</ng-template>

<ng-template #noKeys>
  <div class="flex items-center justify-center w-full h-[400px]">
    <nz-list-empty></nz-list-empty>
  </div>
</ng-template>
